window.addEventListener('message', (e) => {
	const lookup = origins[e.origin];
	if (!lookup) {
		return;
	}

	const { event, message } = lookup.deconstructMessage(e.data);

	if (event && lookup && lookup.events.has(event)) {
		const { components, transform } = lookup;
		for (let component of components) {
			const { dispatch } = component.props;
			dispatch(event, Object.assign({ meta: createMetaData(e.origin) }, transform(component.props, event, formatMessage(message))));
		}
	}

}, false);

const formatMessage = (message) => {
	if (typeof message === 'object' && !Array.isArray(message)) {
		return message;
	}

	return { message };
};

const origins = {
	'*': {
		events: new Set(),
		components: new Set()
	}
};
const add = (set, events) => {
	events.forEach((event) => {
		set.add(event);
	});
	return set;
};

const createMetaData = (origin) => {
	return {
		origin,
		timestamp: (new Date()).getTime()
	};
};

const create = (events = [], component, config = {}) => {
	const configuration = Object.assign({ origin: '*', target: null }, config);
	const { dispatch } = component.props;
	const { origin } = configuration;
	const lookup = origins[origin] || (origins[origin] = {});
	lookup.events = !lookup.events ? new Set(events) : add(lookup.events, events);
	lookup.components = !lookup.components ? new Set([component]) : lookup.components.add(component);
	lookup.constructMessage = config.constructMessage || ((data) => data);
	lookup.deconstructMessage = config.deconstructMessage || ((data) => data);
	lookup.transform = config.transform || ((props, event, message) => message);

	return {
		post: (event, message) => {
			const { target, origin } = configuration;
			if (!target && process.env.NODE_ENV !== 'production') { // eslint-disable-line no-undef
				console.warn('[sn-seismic-post-message] target is not defined.'); // eslint-disable-line no-console
			}

			dispatch(event, Object.assign({ meta: createMetaData(window.location.origin) }, formatMessage(message)));
			target.postMessage(lookup.constructMessage(event, message), origin);
		},
		unbind() {
			const lookup = origins[origin];
			return lookup && lookup.components.delete(component);
		},
		target: (target = window) => {
			configuration.target = target;
		}
	};
};

export { create };
